module.exports = __webpack_public_path__ + "static/media/spinner.a129803a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/spinner/spinner.svg
// module id = 361
// module chunks = 0 1 2